module.exports = __webpack_public_path__ + "img/activecampaign.9b4c898e.svg";